import { useMemo } from 'react';
import { useStores } from '../stores/useStores';

/**
 * If trappingZone has a mating distruption and has the correct insect group,
 * then only return trap lures with '10' concentration.
 * Otherwise, if trappingZone has a mating distruption and has an
 * incorrect insect group, then only return trap lures with '1' concentration.
 *
 * @param {object | null} trappingZone
 * @returns {object[]} array
 */
export const useTrappingZoneTrapLures = (trappingZone) => {
  const { traplogStore } = useStores();

  const selectedInsectGroupId = traplogStore.selectedInsectGroupId;
  const trapLures = useMemo(
    () =>
      traplogStore.trapLures.filter((trapLure) => {
        // If the selected trapping zone has a mating distruption and has
        // correct insect group, then only display lures with '10' concentration.
        // Otherwise, if selected trapping zone has a mating distruption and has
        // incorrect insect group, then only display lures with '1' concentration.
        if (trappingZone) {
          const matingDistruption = trappingZone.mating_disruption_tie;
          if (matingDistruption) {
            return trapLure.insects.some((insect) => {
              if (insect.insect_group_id === selectedInsectGroupId) {
                if (
                  matingDistruption.insects.some(
                    (insect) => insect.insect_group_id === selectedInsectGroupId
                  )
                ) {
                  return trapLure.concentration === '10';
                } else {
                  return trapLure.concentration === '1';
                }
              }
            });
          } else {
            return trapLure.insects.some(
              (insect) =>
                insect.insect_group_id === selectedInsectGroupId &&
                trapLure.concentration !== '10'
            );
          }
        }
        return trapLure.insects.some(
          (insect) => insect.insect_group_id === selectedInsectGroupId
        );
      }),
    [traplogStore.trapLures, trappingZone, selectedInsectGroupId]
  );

  return trapLures;
};
